/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:21:26
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Switch,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import styles from '../../functionSettingTabs.module.css'
import _ from 'lodash'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { getSettingDetail, saveSettingLabel, selectSettings, selectTenant } from '../../../user/setting/settingSlice'
import { PayMethod } from '../../../../models/payment'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'
import { selectEdition } from '../../../../app/applicationSlice'
import { getTenantPreferencesListAsync } from '../../../treatment/editor/recipeEditorSlice'
import { AddOrEditDecoctingPersionalSettingModal } from '../../../treatment/editor/modals/AddOrEditDecoctingPersionalSettingModal'
import { DecoctingPersionalSettingModal } from '../../../treatment/editor/modals/DecoctingPersionalSettingModal'
import { getSaveSomeFunctions } from '../../../registration/register/registerSlice'
import { RecipeNormalFrequencyCategories, RecipeNormalFrequencyName, RecipeNormalUsemethodCategories, RecipeNormalUsemethodName, RecipeNormalDoseCategories, RecipeNormalDoseTypeName } from '../../../../models/decoctingSettingModal'

export const PharmacyRetailSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [complaintNumber, setComplaintNumber] = useState('0')

  const [buttonLoading, setButtonLoading] = useState(false)

  const [recipeFormulationSetup, setRecipeFormulationSetup] = useState(false)

  const [recipeFormulation, setRecipeFormulation] = useState<{
    recipeNormalFrequency?: string
    recipeNormalUsemethod?: string
    recipeNormalDose?: string
  }>({})

  const [isOpenReplaceMake, setIsOpenReplaceMake] = useState(false) //是否开通代煎

  const [
    isDecoctingPersionalSettingModalVisible,
    setIsDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置

  const [
    isAddOrEditDecoctingPersionalSettingModalVisible,
    setIsAddOrEditDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置

  const [selectId, setSelectId] = useState<any>()

  const [selectSupplierId, setSelectSupplierId] = useState<any>()

  const [selectPotionType, setSelectPotionType] = useState<any>()

  const [batchPriceType, setBatchPriceType] = useState('0') // 混合批次开出时的单价采用方式：0=平均值, 1=原批次价格

  const [kcbzsValue, setKcbzsValue] = useState('0') // 库存不足时当前选中的值，用于控制UI展示

  const isCheck = (checkState?: any) => {
    dispatch(getTenantPreferencesListAsync())
      .then(unwrapResult)
      .then((v) => {
        const defaultSelectedData = v?.filter((item: any) => {
          return item?.defaultSelected == 1
        })
        if (v?.length) {
          setIsOpenReplaceMake(true)
        } else {
          setIsOpenReplaceMake(false)
        }
        if (checkState) {
          if (!defaultSelectedData?.length) {
            Modal.confirm({
              title: '提示',
              content: (
                <p>
                  您还没有设置默认代煎偏好
                  <span
                    style={{
                      padding: '0 10px',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: '#027AFF',
                    }}
                    onClick={() => {
                      Modal.destroyAll()
                      setIsAddOrEditDecoctingPersionalSettingModalVisible(true)
                    }}
                  >
                    去设置
                  </span>
                </p>
              ),
              okButtonProps: { style: { display: 'none' } }, // 隐藏确定按钮
              onCancel: () => {
                form.setFieldsValue({
                  "131": false,
                })
              }
            })
          }
        }
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '13') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '13') {
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        const SPJJValue = settings[Checks.SPJJ]
        form.setFieldsValue({
          ...settings,
          [Checks.FZCFJG]: settings[Checks.FZCFJG] || ['1', '2', '3'],
          [Checks.FZCTJG]: settings[Checks.FZCTJG] || ['1', '2', '3'],
          [Checks.SZYLJS]: settings[Checks.SZYLJS] || '0',
          [Checks.WHYLJS]: settings[Checks.WHYLJS] || '0',
          [Checks.CFYDJ]: settings[Checks.CFYDJ],
          [Checks.MHJSMDJ]: settings[Checks.MHJSMDJ],
          [Checks.MHJXGSL]: settings[Checks.MHJXGSL] || 2,
          [Checks.SPJJ]: SPJJValue || '0',
          [Checks.CSCFJXSZ]: settings[Checks.CSCFJXSZ] || '1',
        })
        // 库存不足时回显
        const kcbzs = settings[Checks.KCBZS]
        if (kcbzs) {
          if (kcbzs === '2') {
            setKcbzsValue('2')
            form.setFieldsValue({ [Checks.KCBZS]: '2' })
          } else {
            setKcbzsValue('0')
            form.setFieldsValue({ [Checks.KCBZS]: '0' })
            setBatchPriceType(kcbzs)
          }
        } else {
          // 默认：混合批次开出 + 平均值
          form.setFieldsValue({ [Checks.KCBZS]: '0' })
        }

        const saved = settings?.[Checks.CSCFJXSZNR]
        if (saved) {
          try {
            setRecipeFormulation(JSON.parse(saved))
          } catch {
            console.error('解析失败', saved)
          }
        } else {
          setRecipeFormulation({
            recipeNormalFrequency: '每日一帖',
            recipeNormalUsemethod: '每帖一次',
            recipeNormalDose: '每次100ml',
          })
        }
      }
    }
  }, [settings, props?.selectedTab])

  return (
    <>
      <Col className={styles.settingOutPatient}>
        <Form
          form={form}
          onFinish={(values) => {
            // 检查复制处方价格设置是否选择
            const fzcfjgValue = values[Checks.FZCFJG]
            if (!fzcfjgValue || fzcfjgValue.length === 0) {
              notification.warning({ message: '请选择复制处方价格设置', duration: 3 })
              return
            }

            // 检查添加套餐价格设置是否选择
            const fzctjgValue = values[Checks.FZCTJG]
            if (!fzctjgValue || fzctjgValue.length === 0) {
              notification.warning({ message: '请选择添加套餐价格设置', duration: 3 })
              return
            }
            const pattern = /^[0-9]*$/

            const t = _.chain(values)
              .omitBy((_, k) => pattern.test(k))
              .value() as Tenant

            const f = _.chain(values)
              .pickBy((_, k) => pattern.test(k))
              .mapValues(
                (v, k) =>
                ({
                  type: k,
                  value: v?.toString(),
                } as Settinglable)
              )
              .values()
              .value()
            setButtonLoading(true)
            dispatch(
              saveSettingLabel({
                tenant: {
                  ...tenant,
                  ...t,
                },
                functionList: f,
              })
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功,部分配置需要重新登陆后生效',
                  duration: 3,
                })
                dispatch(getSettingDetail())
              })
              .catch(() => {
                notification.error({ message: '机构设置保存失败', duration: 3 })
                dispatch(getSettingDetail())
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              开方设置
            </Row>
            <div style={{ marginTop: '16px' }}>

              <Col className={styles.rowHeight} span={24}>
                <Form.Item label='药品搜索方式：' name={Checks.YPSSFS}>
                  <Radio.Group
                    onChange={(e) => {
                      return
                    }}
                  >
                    <Radio value={'1'}>药品名称或追溯码搜索</Radio>
                    <Radio value={'0'}>药品名称或条形码搜索</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item label='商品进价' name={Checks.SPJJ}>
                  <Radio.Group value={complaintNumber}
                    onChange={(e) => {
                      setComplaintNumber(e.target.value)
                    }}>
                    <Radio value={'1'}>显示</Radio>
                    <Radio value={'0'}>隐藏</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='处方药销售登记'
                  name={Checks.CFYDJ}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，开处方药时需要做处方信息的登记
                </span>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='麻黄碱实名登记'
                  name={Checks.MHJSMDJ}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，开麻黄碱药品时需要做身份证号等信息的登记
                </span>
              </Col>
              <Col className={styles.rowHeightNum} span={24}>
                <Form.Item
                  label='麻黄碱-OTC限购数量'
                  name={Checks.MHJXGSL}
                >
                <Input addonBefore='单次最多' addonAfter='个最小包装' style={{ width: 260 }}/>
                </Form.Item>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='麻黄碱-OTC限购拦截'
                  name={Checks.MHJXGLJ}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，开麻黄碱药品超出限购数量，强制拦截，禁止结算
                </span>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='皮试管理'
                  name={Checks.Psgl}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，开处方时设置了皮试的药品需要先进行皮试，皮试结果登记后才能进行结算
                </span>
              </Col>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='零库存开药'
                  name={Checks.Lkcky}
                  valuePropName='checked'
                >
                  <Switch
                    checkedChildren='开启'
                    unCheckedChildren='关闭'
                    onChange={(v: any) => {
                      dispatch(
                        setSettings({
                          [Settings.Recipe.TcmIgnoreStorage]: v,
                          [Settings.Recipe.IgnoreStorage]: v,
                          [Settings.Recipe.TcmUseSpecifiedBatch]: !v,
                          [Settings.Recipe.UseSpecifiedBatch]: !v,
                        })
                      )
                    }}
                  ></Switch>
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后，开方搜索范围为商品目录列表，并且不需要发药
                </span>
              </Col>
              {hisVersion != 1 ? (
                <Col className={styles.herbalCopySetting} span={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item label='中药方初始处方剂型' name={Checks.CSCFJXSZ} style={{ marginBottom: 0 }}>
                      <Radio.Group
                        onChange={(e) => {
                          return
                        }}
                        defaultValue={'1'}
                      >
                        <Radio value={'1'}>沿用上次机构开方的处方剂型</Radio>
                        <Radio value={'0'}>固定处方剂型</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <a onClick={() => {
                      setRecipeFormulationSetup(true)
                    }}>去设置</a>
                  </div>
                </Col>) : <></>}
              <Col className={styles.rowHeight} span={24}>
                <Form.Item
                  label='代煎偏好设置'
                >
                  <Button type='primary' onClick={() => {
                    isCheck()
                    setIsAddOrEditDecoctingPersionalSettingModalVisible(true)
                  }}>代煎偏好设置</Button>
                </Form.Item>
              </Col>
            </div>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
                marginBottom: '16px',
              }}
            >
              复制处方/添加套餐设置
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}>库存不足时 :</Col>
              <Col style={{ flex: 1 }}>
                <Radio
                  checked={kcbzsValue !== '2'}
                  onChange={() => {
                    setKcbzsValue('0')
                    form.setFieldsValue({ [Checks.KCBZS]: batchPriceType })
                  }}
                >
                  混合批次开出
                </Radio>
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeight} style={{ flex: 1, marginBottom: 0 }}>
                使用库存价格时，单价采用
                <Select
                  value={batchPriceType}
                  onChange={(v) => {
                    setBatchPriceType(v)
                    setKcbzsValue('0')
                    form.setFieldsValue({ [Checks.KCBZS]: v })
                  }}
                  style={{ width: '120px', margin: '0 8px' }}
                  options={[
                    { label: '平均值', value: '0' },
                    { label: '原批次价格', value: '1' },
                  ]}
                />
                ，使用处方价格和使用目录价格时不受批次影响
              </Col>
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col style={{ flex: 1 }}>
                <Radio
                  checked={kcbzsValue === '2'}
                  onChange={() => {
                    setKcbzsValue('2')
                    form.setFieldsValue({ [Checks.KCBZS]: '2' })
                  }}
                >
                  下一批次开出
                </Radio>
                <span style={{ color: '#999' }}>自动取下一个足够本次数量的批次</span>
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeight} style={{ flex: 1, marginBottom: 0 }}>
                使用库存价格时，单价采用下一批次的价格，使用处方价格和使用目录价格时不受批次影响
              </Col>
            </Row>
            <Form.Item name={Checks.KCBZS} hidden>
              <Input />
            </Form.Item>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}>复制处方价格设置 :</Col>
              <Col style={{ flex: 1, }}>
                选择支持的价格，如选择多个则开方时再根据情况选择，如选择一个则开方时无需再次选择
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '16px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeights} style={{ flex: 1 }}>
                <Form.Item name={Checks.FZCFJG}>
                  <Checkbox.Group>
                    <Checkbox value={'1'}>使用目录价格</Checkbox>
                    <Checkbox value={'2'}>使用处方价格</Checkbox>
                    <Checkbox value={'3'}>使用库存价格<span style={{ color: '#606266' }}>（选择库存价格时诊疗使用目录价格）</span></Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}>添加套餐价格设置 :</Col>
              <Col style={{ flex: 1, }}>
                选择支持的价格，如选择多个则开方时再根据情况选择，如选择一个则开方时无需再次选择
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '16px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeights} style={{ flex: 1 }}>
                <Form.Item name={Checks.FZCTJG}>
                  <Checkbox.Group>
                    <Checkbox value={'1'}>使用目录价格</Checkbox>
                    <Checkbox value={'2'}>使用套餐价格</Checkbox>
                    <Checkbox value={'3'}>使用库存价格<span style={{ color: '#606266' }}>（选择库存价格时诊疗使用目录价格）</span></Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            {hisVersion !== 1 ?
              <>
                <Col className={styles.herbalCopySetting} span={24}>
                  <Row className={styles.herbalCopyLabelRow}>
                    <Col className={styles.titleLineHeight}>中药方复制设置:</Col>
                    <Col className={styles.herbalCopyLabelText}>
                      中药方复制时，处方剂型默认值设置，请选项以下一种方式
                    </Col>
                  </Row>
                  <Form.Item
                    className={styles.herbalCopyRadioItem}
                    label=' '
                    colon={false}
                    name={Checks.ZYFCOPY}
                    initialValue={'0'}
                  >
                    <Radio.Group className={styles.squareRadioGroup}>
                      <Radio value={'0'}>沿用复制的历史处方的处方剂型</Radio>
                      <Radio value={'1'}>不复制历史处方的处方剂型</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

              </> :
              <></>}
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
              }}
            >
              开药量自动计算设置
            </Row>
            <div style={{ marginTop: '16px' }}>
              <Row style={{ display: 'flex' }}>
                <Col className={styles.titleLineHeight}>开方自动计算 :</Col>
                <Col className={styles.rowHeight} style={{ flex: 1 }}>
                  <Form.Item name={Checks.ZDJSTS} valuePropName='checked'>
                    <Checkbox>自动计算天数(保存前)</Checkbox>
                  </Form.Item>
                  <Form.Item name={Checks.ZDJSTSBCH} valuePropName='checked'>
                    <Checkbox>自动计算天数(保存后)</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              {settings[Checks.MLKG] == 1 ?
                <>
                  {/* // 新老目录展示方式 spec=>packSpec */}
                  <Row className={styles.YLJSSetting} >
                    <Col className={styles.titleLineHeights}>输注用量计算:</Col>
                    <Col>
                      <Form.Item label='' name={Checks.SZYLJS}>
                        <Radio.Group>
                          <Row style={{ height: '36px' }}>
                            <Radio value={'0'}>
                              <span>标准型：单次药品未用完时丢弃</span>
                              <span className={styles.nameTips}>例如：规格为20ml/支，单次注射10ml，一天2次。系统计算总开药量为：2支</span></Radio>
                          </Row>
                          <Row style={{ height: '36px' }}>
                            <Radio value={'1'}>
                              <span>节约型：单次药品未用完时保留</span>
                              <span className={styles.nameTips}>例如：规格为20ml/支，单次注射10ml，一天2次。系统计算总开药量为：1支</span>
                            </Radio>
                          </Row>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className={styles.YLJSSetting} >
                    <Col className={styles.titleLineHeights}>雾化用量计算:</Col>
                    <Col>
                      <Form.Item label='' name={Checks.WHYLJS}>
                        <Radio.Group>
                          <Row style={{ height: '36px' }}>
                            <Radio value={'0'}>
                              <span>标准型：单次药品未用完时丢弃</span>
                              <span className={styles.nameTips}>例如：规格为400ug/支，单次雾化200ug，一天2次。系统计算总开药量为：2支</span></Radio>
                          </Row>
                          <Row style={{ height: '36px' }} >
                            <Radio value={'1'}>
                              <span>节约型：单次药品未用完时保留</span>
                              <span className={styles.nameTips}>例如：规格为400ug/支，单次雾化200ug，一天2次。系统计算总开药量为：1支</span>
                            </Radio>
                          </Row>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                </> :
                <></>}
            </div>
          </div>
          <Row style={{ paddingTop: '10px' }}>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  dispatch(getSettingDetail())
                }}
                style={{
                  float: 'right',
                  marginRight: '10px',
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{
                  float: 'left',
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </Col >
      <AddOrEditDecoctingPersionalSettingModal
        visible={isAddOrEditDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        addPersionalMessage={(potionType, supplierId, id) => {
          setSelectPotionType(potionType)
          setSelectSupplierId(supplierId)
          setSelectId(id)
          setIsDecoctingPersionalSettingModalVisible(true)
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
      ></AddOrEditDecoctingPersionalSettingModal>

      <DecoctingPersionalSettingModal
        selectSupplierId={selectSupplierId}
        selectId={selectId}
        selectPotionType={selectPotionType}
        isOpenReplaceMake={isOpenReplaceMake}
        visible={isDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
      ></DecoctingPersionalSettingModal>

      <Modal
        title="处方用法"
        width={700}
        visible={recipeFormulationSetup}
        bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}
        onCancel={() => setRecipeFormulationSetup(false)}
        onOk={() => {

          const params: any = [
            {
              type: Checks.CSCFJXSZNR,
              value: JSON.stringify(recipeFormulation),
            },
          ]
          // TODO: 保存处方剂型设置
          dispatch(getSaveSomeFunctions({ functionList: params }))
            .then(unwrapResult)
            .then((res: any) => {
              setRecipeFormulationSetup(false)
            })
        }}
      >
        <Form.Item label="处方剂型" style={{ marginBottom: 0 }}>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalFrequency}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalFrequency: val })
            }
            style={{ width: 150, marginRight: 10 }}
          >
            {RecipeNormalFrequencyCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalFrequencyName(v)}
                </Select.Option>
              )
            })}
          </Select>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalUsemethod}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalUsemethod: val })
            }
            style={{ width: 150, marginRight: 10 }}
          >
            {RecipeNormalUsemethodCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalUsemethodName(v)}
                </Select.Option>
              )
            })}
          </Select>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalDose}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalDose: val })
            }
            style={{ width: 150 }}
          >
            {RecipeNormalDoseCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalDoseTypeName(v)}
                </Select.Option>
              )
            })}
          </Select>
        </Form.Item>
      </Modal>
    </>
  )
}
